var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnfencedYard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M31 30.5v1a.5.5 0 0 1-.5.5h-29a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H15v-4.069c-4.513-.53-8-4.07-8-9.43 0-4.448 5.365-11.73 7.897-14.92A57 57 0 0 1 16.192 0s.5.606 1.26 1.607C19.887 4.811 25 12.065 25 16.501c0 4.964-3.34 9.038-8 9.462V30h13.5a.5.5 0 0 1 .5.5m-8-13.999c0-1.023-.408-2.467-1.198-4.208-.769-1.696-1.813-3.485-2.884-5.138a72 72 0 0 0-2.76-3.943 72 72 0 0 0-2.906 3.976c-1.118 1.653-2.206 3.44-3.008 5.134C9.419 14.064 9 15.497 9 16.502c0 4.22 2.582 6.908 6 7.412v-8.868l-2.217-1.606a1 1 0 1 1 1.174-1.62l1.043.756V11a1 1 0 1 1 2 0v6.576l1.043-.756a1 1 0 0 1 1.174 1.62L17 20.046v3.905c3.411-.415 6-3.442 6-7.45",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
})))));
export default SvgUnfencedYard;